import "./style.scss"
$(document).ready(function(){
    var d = new Date();
    var n = d.getFullYear();
    $('.copyright .year').append(n);
    
    $(window).on('resize',function() {
        if($(window).width() < 769){
            $('footer .copyright').insertAfter($('footer .socialmedia'));
        }else{
            $('footer .copyright').insertBefore($('footer .info'));
        }
    }).trigger('resize');   
      
})



